<template>
  <v-container
    class="fill-height d-flex flex-column justify-center align-center"
    fluid
    style="background: linear-gradient(135deg, #1a2842, #495e79)"
  >
    <transition name="scale-fade" appear>
      <v-img
        :src="require('@/assets/mobipoly-logo.png')"
        alt="Mobipoly Logo"
        width="150"
        height="150"
        class="mb-4"
      />
    </transition>
  </v-container>
</template>

<script>
export default {
  name: "SplashScreen",
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.show = true; // Trigger animation on mount
    setTimeout(() => {
      this.$router.replace("/choosescreen");
    }, 3000); // Show screen for 3 seconds
  },
};
</script>

<style>
.scale-fade-enter-active {
  animation: scaleFadeIn 1.5s ease forwards;
}
@keyframes scaleFadeIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
